export type PriceSuggestionType =
  | 'MARKUP'
  | 'MG_AGGRESSIVE'
  | 'MG_CONSERVATIVE'
  | 'MG_MODERATE'
  | 'FINFO_BASE'
  | 'FINFO_RECOMMENDED'
  | 'LOCAL'
  | 'BRAND'
  | 'MG_VVS';

export const priceSuggestionOptions = [
  'MARKUP',
  'MG_AGGRESSIVE',
  'MG_CONSERVATIVE',
  'MG_MODERATE',
  'FINFO_BASE',
  'FINFO_RECOMMENDED',
  'LOCAL',
  'BRAND',
  'MG_VVS',
] as const;

export interface PriceSuggestionPriority {
  priority: number;
  priceSuggestionType: PriceSuggestionType;
}
